import React, {useEffect, useState} from "react";
import {
    Box,
    Grid,
    Typography,
    Button,
    IconButton,
    TextField,
    alpha,
    useTheme,
    useMediaQuery,
    Tooltip as MuiTooltip,
} from "@mui/material";
import {styled} from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {ApiDetails, KEY} from "../../../Constants";
import CryptoJS from "crypto-js";
import {showSnackbar} from "../../../components/SnackBar/SnackBar";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import LeftSide from "./Left Side/LeftSide";
import RightSide from "./Right Side/RightSide";
import {DataGrid} from "@mui/x-data-grid";
import {makeStyles} from "@material-ui/core/styles";
import {useConfirm} from "material-ui-confirm";
import useGoBack from "../../../components/useGoBack";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CardBillingConfirmationDialog from './cardBillingConfirmatinDialog'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CloseIcon from '@mui/icons-material/Close';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import WarningIcon from "@mui/icons-material/Warning";
import GetAppIcon from "@mui/icons-material/GetApp";
import WaterDropIcon from "@mui/icons-material/Water";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import {Tooltip} from "recharts";
import { handle401Unauthorized, handle403Forbidden } from '../../../utils/authErrorHandler';
import { getUserData } from '../../../services/api/client';


const useStyles = makeStyles({
    root: {
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: "none",
        },
        "& .MuiDataGrid-columnHeaders": {
            fontSize: 16,
            color: "darkblue",
            backgroundColor: "rgb(245,245,245)",
        },
    },
});


const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    "& .MuiDataGrid-root": {
        minHeight: "200px", // Minimum height for empty states
        maxHeight: "600px", // Maximum height to prevent excessive growth
        height: "auto", // Auto height based on content
        overflowY: "auto",  // Enables scrolling when needed
    },
    "& .MuiDataGrid-columnHeaders": {
        fontSize: "1rem",
        fontWeight: 700,
        backgroundColor: "#E3F2FD", // Light blue background
        color: "#0D47A1", // Dark blue text
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: "#f5faf5", // Light green hover color
    },
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
    "& .MuiDataGrid-cell": {
        fontSize: "0.9rem",
    },
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
    dialogTitle: {
        textAlign: "center",
        fontWeight: "bold",
        color: "#2C5283",
        padding: "16px",
        borderBottom: "2px solid #2C5283",
    },
    dialogContent: {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    container: {
        height: "500px",
        width: "100%",
        maxWidth: "90vw",
        backgroundColor: "#F9FAFB",
        borderRadius: "8px",
        // padding: "15px",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
    },
    billingHeader: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "20px",
    },
    label: {
        fontSize: "1rem",
        fontWeight: 600,
        color: "#444",
    },
    cancelButton: {
        color: "#d32f2f",
        borderColor: "#d32f2f",
        "&:hover": {
            backgroundColor: "rgba(211, 47, 47, 0.1)",
        },
    },
    billButton: {
        backgroundColor: "#2C5283",
        color: "white",
        "&:hover": {
            backgroundColor: "#1E3A63",
        },
    },
};

const CustomerPage = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    // Mobile menu state
    const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
    const mobileMenuOpen = Boolean(mobileMenuAnchor);

    const handleMobileMenuOpen = (event) => {
        setMobileMenuAnchor(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMenuAnchor(null);
    };

    let myMapDetailsDecrypted = "";

    try {
        myMapDetailsDecrypted = CryptoJS.AES.decrypt(localStorage.getItem("myMap"), KEY);

    } catch (e) {
        console.log(e);
    }

    const [tenantList, setTenantList] = useState([]);


    const originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);

    // Helper function to get auth token
    const getAuthToken = () => {
        const userData = getUserData();
        return userData ? userData.find(([key]) => key === 'access_token')?.[1] : null;
    };

    const label = {inputProps: {"aria-label": "Switch demo"}};


    const [tenantData, setTenantData] = useState({
        first_name: "n/a",
        last_name: "n/a",
        phone_number: "",
        secondary_phone_number: "",
        email_address: "",
        account_number: "",
        house_number: "",
        Wallet: 0,
        status: "",
        state: ""
    });

    const [files, setFiles] = useState({
        "tenant_photo": {
            "base64": "No File Found",
            "extension": "Not Specified"
        },
        "photo_of_national_id": {
            "base64": "No File Found",
            "extension": "Not Specified"
        },
        "copy_of_contract": {
            "base64": "No File Found",
            "extension": "Not Specified"
        },
        "inventory_checklist": {
            "base64": "No File Found",
            "extension": "Not Specified"
        }
    });

    useEffect(() => {
        // Fetch the tenant data
        fetch(ApiDetails + "pegasus/visionary/tenant/get/specific/tenant", {
            method: "POST",
            body: JSON.stringify({tenant_id: props.tenant_id, property_id: props.property_id}),
            headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""  // Replace with your actual token variable
            },
        })
            .then((response) => response.json())
            .then((data) => {

                setTenant(data);
                setTenantData(data);
                setTenantList([data]);

                setWaterBill(data.water_bill)
                setElectricityBill(data.electricity_bill)

                setMinimumWaterBill(data.minimum_water_bill)
                setMinimumElecBIll(data.minimum_electricity_bill)


            })
            .catch((err) => console.error(err));

    }, []);

    useEffect(() => {
        // Fetch the image from the server
        fetch(
            ApiDetails +
            "pegasus/visionary/tenant/fetch/tenant/files",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": getAuthToken() || ""  // Replace with your actual token variable
                },
                body: JSON.stringify({
                    tenant_id: props.tenant_id,
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    let pic;
                    pic = data.tenant_photo;
                    setFiles(data)


                    if (
                        pic.base64 !== "No File Found" &&
                        pic.base64.toString().trim() !== ""
                    ) {
                        // console.log("TRUE")
                        setImageSrc("data:image/jpeg;base64," + pic.base64);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const [imageSrc, setImageSrc] = useState("");

    const [bills, setBills] = useState([]);


    const getTenantBills = () => {
        fetch(ApiDetails + "pegasus/visionary/tenant/bills", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""  // Replace with your actual token variable
            },
            body: JSON.stringify({
                tenant_id: props.tenant_id,
            }),
        })
            .then(async (response) => {
                let bills = await response.json();
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    console.log(bills);

                    //Fetch tenant transactions
                    // setBills(bills);
                    // setInvoicesModal(true);

                    showSnackbar({
                        title: "Success!",
                        message: "Bill retrieved successfully.",
                        type: "success", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });

                } else if (response.status === 404) {
                    showSnackbar({
                        title: "Error!",
                        message: "Bill not found.",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                } else {

                    showSnackbar({
                        title: "Error!",
                        message: "Failed fetching tenant's latest bill..",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something Went Wrong. Call Customer Care For Assistance.",
                    type: "error", // Options: success, error, warning, info
                    position: {vertical: "bottom", horizontal: "right"}, // Options for position
                });
            });
    };

    const [billTenantsModal, setBillTenantsModal] = useState(false);
    let [billedTenants, setBilledTenants] = useState([]);

    // Add these state variables to your component
    const [showBillingConfirmDialog, setShowBillingConfirmDialog] = useState(false);
    const [billingDataForConfirm, setBillingDataForConfirm] = useState(null);

    const [waterBill, setWaterBill] = useState();
    const [minimumWaterBill, setMinimumWaterBill] = useState();

    const [electricityBill, setElectricityBill] = React.useState(0);
    const [minimumElecBill, setMinimumElecBIll] = React.useState(0);

    let [elecBilledTenants, setElecBilledTenants] = useState([]);

    let [tenantsLength, setTenantsLength] = useState(1);

    const getRowStyle = (params) => ({
        backgroundColor: params.row.billing_enabled ? "transparent" : "#f0f0f0",
        color: params.row.billing_enabled ? "inherit" : "#888",
        pointerEvents: params.row.billing_enabled ? "auto" : "none",
        opacity: params.row.billing_enabled ? 1 : 0.6,
    });

    const billingColumns = [
        {
            field: "user",
            headerName: "Name",
            flex: 1,
            minWidth: 120,
            sortOrder: "asc",
            renderCell: (params) => {
                return (
                    <div className="userListUser">
                        {params.row.first_name} {params.row.last_name}
                    </div>
                );
            },
        },
        {
            field: "house_number", // align: "center",
            headerName: "HSE NO",
            flex: 1,
            minWidth: 80,
        },
        {
            field: "rent",
            headerName: "Rent",
            flex: 1,
            minWidth: 50, // align: "center",
            renderCell: (params) => {
                return (
                    <div style={{color: "green"}}>
                        {parseInt(
                            params.row.rent.toString().replace(",", "")
                        ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "KSH",
                        })}
                    </div>
                );
            },
        },
        {
            field: "bill",
            headerName: "Wallet",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <span
                    style={{
                        ...getRowStyle(params),
                        color: params.row.status === "PENDING" ? "#D32F2F" : "#388E3C",
                    }}
                >
                {params.row.Wallet.toLocaleString("en-US", {
                    style: "currency",
                    currency: "KSH",
                })}
            </span>
            ),
        },

        {
            field: "meter_reading",
            headerName: "Prior Water Reading",
            flex: 1,
            minWidth: 120, // align: "center",
            renderCell: (params) => {
                return <div>{params.row.meter_reading}</div>;
            },
        },
        {
            field: "current_meter_reading",
            headerName: "Water Reading",
            flex: 1,
            minWidth: 100, // align: "center",
            renderCell: (params) => {
                return (
                    <div className="userListAction">
                        <TextField
                            type={"number"}
                            placeholder="Enter Reading ..."
                            onChange={(e) => {
                                let filteredTenantArray = billedTenants.filter((tenant) => {
                                    return tenant.tenant_id !== params.row.tenant_id;
                                });

                                if (
                                    e.target.value === undefined ||
                                    e.target.value === null ||
                                    e.target.value === ""
                                ) {
                                    return;
                                }

                                let consumedUnits = e.target.value - params.row.meter_reading;
                                consumedUnits = consumedUnits.toFixed(1);

                                let finalWaterBill =
                                    parseFloat(consumedUnits) * parseInt(waterBill);

                                if (finalWaterBill < minimumWaterBill) {
                                    finalWaterBill = minimumWaterBill;
                                }

                                // Use Wallet as arrears only if status is PENDING
                                const arrears = params.row.status === "PENDING" ? parseFloat(params.row.Wallet || 0) : 0;
                                setBilledTenants([
                                    ...filteredTenantArray,
                                    {
                                        tenant_id: params.row.tenant_id,
                                        rent: parseInt(params.row.rent.replace(",", "")),
                                        arrears: arrears,
                                        status: params.row.status,
                                        finalWaterBill: parseFloat(finalWaterBill),
                                        total_bill:
                                            parseInt(params.row.rent.replace(",", "")) +
                                            arrears +
                                            parseFloat(finalWaterBill),
                                        meter_reading: e.target.value,
                                        landlord_id: JSON.parse(originalText)[0][1],
                                    },
                                ]);
                            }}
                            disabled={!params.row.billing_enabled}
                        />
                    </div>
                );
            },
        },

        {
            field: "electricity_meter_reading",
            headerName: "Prior Elec Reading",
            flex: 1,
            minWidth: 80,
        },
        {
            field: "current_electricity_meter_reading",
            headerName: "Electricity Reading",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <div className="userListAction">
                        <TextField
                            type={"number"}
                            placeholder="Enter Reading ..."
                            onChange={(e) => {
                                let filteredTenantArray = elecBilledTenants.filter((tenant) => {
                                    return tenant.tenant_id !== params.row.tenant_id;
                                });
                                if (
                                    e.target.value === undefined ||
                                    e.target.value === null ||
                                    e.target.value === ""
                                ) {
                                    return;
                                }
                                let consumedUnits =
                                    e.target.value - params.row.electricity_meter_reading;
                                consumedUnits = consumedUnits.toFixed(1);

                                // console.log(
                                //   "Prior elec reading: " + params.row.electricity_meter_reading
                                // );
                                // console.log("Current elec reading: " + e.target.value);
                                // console.log("Consumed units: " + consumedUnits);
                                let finalElecBill =
                                    parseFloat(consumedUnits) * parseInt(electricityBill);

                                // console.log("Final elec bill: " + finalElecBill);

                                if (finalElecBill < minimumElecBill) {
                                    finalElecBill = minimumElecBill;
                                }

                                // Use Wallet as arrears only if status is PENDING
                                const arrears = params.row.status === "PENDING" ? parseFloat(params.row.Wallet || 0) : 0;
                                setElecBilledTenants([
                                    ...filteredTenantArray,
                                    {
                                        tenant_id: params.row.tenant_id,
                                        rent: parseInt(params.row.rent.replace(",", "")),
                                        arrears: arrears,
                                        status: params.row.status,
                                        electricity_bill: parseFloat(finalElecBill),
                                        total_bill:
                                            parseInt(params.row.rent.replace(",", "")) +
                                            arrears +
                                            parseFloat(finalElecBill),
                                        electricity_meter_reading: e.target.value,
                                        landlord_id: JSON.parse(originalText)[0][1],
                                    },
                                ]);
                            }}
                            disabled={!params.row.billing_enabled}
                        />
                    </div>
                );
            },
        },
    ];

    const getBillingMonth = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0-based index (Jan = 0, Feb = 1, etc.)
        const day = today.getDate();

        if (day >= new Date(year, month + 1, 0).getDate() - 4 || day <= 10) {
            // Last 5 days of the month OR first 10 days of the new month
            return new Date(year, month + 1, 1); // Select Next Month
        } else {
            return new Date(year, month, 1); // Select Current Month
        }
    };

    const [month, setMonth] = useState(getBillingMonth());

    const [selectedMonth, setSelectedMonth] = useState(getBillingMonth());

    const [billLoading, setBillLoading] = React.useState(false);

    const confirm = useConfirm();

    function getMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);

        return date.toLocaleString("en-US", {month: "long"});
    }

    const [tenant, setTenant] = useState({
        tenant_id: "",
        landlord_id: "",
        first_name: "",
        house_number: "",
        occupation_or_profession: "",
        last_name: "",
        email_address: "",
        phone_number: "",
        national_id: "",
        next_of_kin_relationship: "",
        next_of_kin_first_name: "",
        next_of_kin_last_name: "",
        next_of_kin_national_id: "",
        next_of_kin_contacts: "",
        is_student: "",
        institution_name: "",
        place_of_work: "",
        reason_for_relocating: "",
        previous_residence: "",
        landlord_email_address: "",
        onboarding_secret: "SECRET",
        property_name: "",
        rent: "",
        property_id: "",
        arrears: "",
        amount: "",
        account_number: "",
        account_balance: "",
        bill: "",
        status: "",
        tenant_photo: "",
        inventory_checklist: "",
        copy_of_contract: "",
        photo_of_national_id: "",
        deposit_held: "",
        secondary_phone_number: "",
        bill_details: false,
        notice: {
            reasons_for_vacating: "",
        },
    });

    const [warning, setWarning] = useState("");

    const classes = useStyles();

    const handleClose = () => {
        setBillTenantsModal(false);
    };

    const [htmlContent, setHtmlContent] = useState('');

    const billTenantOld = async () => {

        if (
            billedTenants.length < tenantsLength ||
            elecBilledTenants.length < tenantsLength
        ) {
            showSnackbar({
                title: "Error!",
                message: "Please Make sure to bill both water and electricity",
                type: "error", // Options: success, error, warning, info
                position: {vertical: "bottom", horizontal: "right"}, // Options for position
            });

            setBillLoading(false);

            return;
        }

        let finalBill = [];

        if (billedTenants > elecBilledTenants) {
            billedTenants.forEach((tenant) => {
                elecBilledTenants.forEach((tenant2) => {
                    if (tenant.tenant_id === tenant2.tenant_id) {
                        finalBill = [
                            ...finalBill,
                            {
                                tenant_id: tenant.tenant_id,
                                water_bill: tenant.finalWaterBill,
                                electricity_bill: tenant2.electricity_bill,
                                total_bill:
                                    parseInt(tenant.rent.replace(",", "")) +
                                    parseInt(tenant.arrears) +
                                    parseFloat(tenant2.electricity_bill) +
                                    parseFloat(tenant.finalWaterBill),
                                meter_reading: tenant.meter_reading,
                                electricity_meter_reading: tenant2.electricity_meter_reading,
                                landlord_id: JSON.parse(originalText)[0][1],
                            },
                        ];
                        billedTenants = billedTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                        elecBilledTenants = elecBilledTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                    }
                });
            });
        } else {
            elecBilledTenants.forEach((tenant) => {
                billedTenants.forEach((tenant2) => {
                    if (tenant.tenant_id === tenant2.tenant_id) {
                        finalBill = [
                            ...finalBill,
                            {
                                tenant_id: tenant.tenant_id,
                                water_bill: tenant2.finalWaterBill,
                                electricity_bill: tenant.electricity_bill,
                                total_bill:
                                    parseInt(tenant.rent) +
                                    parseInt(tenant.arrears) +
                                    parseFloat(tenant.electricity_bill) +
                                    parseFloat(tenant2.finalWaterBill),
                                meter_reading: tenant2.meter_reading,
                                electricity_meter_reading: tenant.electricity_meter_reading,
                                landlord_id: JSON.parse(originalText)[0][1],
                            },
                        ];
                        billedTenants = billedTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                        elecBilledTenants = elecBilledTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                    }
                });
            });
        }

        let finalWaterBills = [];
        billedTenants.forEach((reading) => {
            reading = {
                tenant_id: reading.tenant_id,
                water_bill: reading.finalWaterBill,
                electricity_bill: 0,
                total_bill:
                    parseInt(reading.rent) +
                    parseInt(reading.arrears) +
                    parseFloat(reading.finalWaterBill),
                meter_reading: reading.meter_reading,
                electricity_meter_reading: 0,
                landlord_id: JSON.parse(originalText)[0][1],
            };
            finalWaterBills = [...finalWaterBills, reading];
        });

        let finalElectricityBills = [];
        elecBilledTenants.forEach((reading) => {
            reading = {
                tenant_id: reading.tenant_id,
                water_bill: 0,
                electricity_bill: reading.electricity_bill,
                total_bill:
                    parseInt(reading.rent) +
                    parseInt(reading.arrears) +
                    parseFloat(reading.electricity_bill),
                meter_reading: 0,
                electricity_meter_reading: reading.electricity_meter_reading,
                landlord_id: JSON.parse(originalText)[0][1],
            };
            finalElectricityBills = [...finalElectricityBills, reading];
        });

        finalBill = [...finalBill, ...finalWaterBills, ...finalElectricityBills];

        if (selectedMonth === null) {
            showSnackbar({
                title: "Error!",
                message: "Kindly select the month you are billing for.",
                type: "error", // Options: success, error, warning, info
                position: {vertical: "bottom", horizontal: "right"}, // Options for position
            });
            setBillLoading(false);
            return;
        }

        let continueBilling = false;

        // eslint-disable-next-line no-restricted-globals
        await confirm({
            description: `You are about to bill for the month of 
         ${getMonthName(parseInt(month.getMonth())).toUpperCase()} , ${parseInt(
                month.getFullYear()
            )}`,
        })
            .then(() => {
                continueBilling = true;
                setBillLoading(true);
            })
            .catch(() => (continueBilling = false));


        if (!continueBilling) {
            fetch(ApiDetails + "pegasus/visionary/property/enableBilling", {
                method: "POST",
                body: JSON.stringify({
                    property_id: tenant.property_id,
                }),
            })
                .then(async (response) => {
                     // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                        window.location.reload(false);
                    } else {
                        showSnackbar({
                            title: "Error!",
                            message: "Failed updating tenant details.",
                            type: "error", // Options: success, error, warning, info
                            position: {vertical: "bottom", horizontal: "right"}, // Options for position
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    showSnackbar({
                        title: "Error!",
                        message: "Something Went Wrong. Call Customer Care For Assistance.",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                });
            return;
        }

        //Make Billing API Call
        fetch(ApiDetails + "pegasus/visionary/property/bill/tenants", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": getAuthToken() || ""  // Replace with your actual token variable
            },
            body: JSON.stringify([
                ...finalBill,
                {
                    month: parseInt(month.getMonth()),
                    year: parseInt(month.getFullYear()),
                    property_id: tenant.property_id,
                    property_name: tenant.property_name,
                    // email_address: JSON.parse(originalText)[5][1],
                },
            ]),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                    // await getPropertyDetails();
                    // setUpdateState(!updateState);
                    let data = await response.json();

                    console.log(data)

                    setHtmlContent(data.htmlReport);

                    showSnackbar({
                        title: "Success!",
                        message: "Tenants billed successfully.",
                        type: "success", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });

                    setBillLoading(false);

                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Failed Billing tenants.",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                    setBillLoading(false);

                    handleClose();
                }
            })
            .catch((err) => {
                console.log(err);

                showSnackbar({
                    title: "Error!",
                    message: "Something Went Wrong. Call Customer Care For Assistance.",
                    type: "error", // Options: success, error, warning, info
                    position: {vertical: "bottom", horizontal: "right"}, // Options for position
                });

                setBillLoading(false);

                handleClose();
            });
    };

    const billTenant = async () => {
        if (
            billedTenants.length < tenantsLength ||
            elecBilledTenants.length < tenantsLength
        ) {
            showSnackbar({
                title: "Error!",
                message: "Please Make sure to bill both water and electricity",
                type: "error", // Options: success, error, warning, info
                position: {vertical: "bottom", horizontal: "right"}, // Options for position
            });

            setBillLoading(false);
            return;
        }

        let finalBill = [];

        if (billedTenants > elecBilledTenants) {
            billedTenants.forEach((tenant) => {
                elecBilledTenants.forEach((tenant2) => {
                    if (tenant.tenant_id === tenant2.tenant_id) {
                        finalBill = [
                            ...finalBill,
                            {
                                tenant_id: tenant.tenant_id,
                                water_bill: tenant.finalWaterBill,
                                electricity_bill: tenant2.electricity_bill,
                                total_bill:
                                    parseInt(tenant.rent.replace(",", "")) +
                                    parseInt(tenant.arrears) +
                                    parseFloat(tenant2.electricity_bill) +
                                    parseFloat(tenant.finalWaterBill),
                                meter_reading: tenant.meter_reading,
                                electricity_meter_reading: tenant2.electricity_meter_reading,
                                landlord_id: JSON.parse(originalText)[0][1],
                            },
                        ];
                        billedTenants = billedTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                        elecBilledTenants = elecBilledTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                    }
                });
            });
        } else {
            elecBilledTenants.forEach((tenant) => {
                billedTenants.forEach((tenant2) => {
                    if (tenant.tenant_id === tenant2.tenant_id) {
                        finalBill = [
                            ...finalBill,
                            {
                                tenant_id: tenant.tenant_id,
                                water_bill: tenant2.finalWaterBill,
                                electricity_bill: tenant.electricity_bill,
                                total_bill:
                                    parseInt(tenant.rent) +
                                    parseInt(tenant.arrears) +
                                    parseFloat(tenant.electricity_bill) +
                                    parseFloat(tenant2.finalWaterBill),
                                meter_reading: tenant2.meter_reading,
                                electricity_meter_reading: tenant.electricity_meter_reading,
                                landlord_id: JSON.parse(originalText)[0][1],
                            },
                        ];
                        billedTenants = billedTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                        elecBilledTenants = elecBilledTenants.filter(
                            (tenant) => tenant.tenant_id !== tenant2.tenant_id
                        );
                    }
                });
            });
        }

        let finalWaterBills = [];
        billedTenants.forEach((reading) => {
            reading = {
                tenant_id: reading.tenant_id,
                water_bill: reading.finalWaterBill,
                electricity_bill: 0,
                total_bill:
                    parseInt(reading.rent) +
                    parseInt(reading.arrears) +
                    parseFloat(reading.finalWaterBill),
                meter_reading: reading.meter_reading,
                electricity_meter_reading: 0,
                landlord_id: JSON.parse(originalText)[0][1],
            };
            finalWaterBills = [...finalWaterBills, reading];
        });

        let finalElectricityBills = [];
        elecBilledTenants.forEach((reading) => {
            reading = {
                tenant_id: reading.tenant_id,
                water_bill: 0,
                electricity_bill: reading.electricity_bill,
                total_bill:
                    parseInt(reading.rent) +
                    parseInt(reading.arrears) +
                    parseFloat(reading.electricity_bill),
                meter_reading: 0,
                electricity_meter_reading: reading.electricity_meter_reading,
                landlord_id: JSON.parse(originalText)[0][1],
            };
            finalElectricityBills = [...finalElectricityBills, reading];
        });

        finalBill = [...finalBill, ...finalWaterBills, ...finalElectricityBills];

        if (selectedMonth === null) {
            showSnackbar({
                title: "Error!",
                message: "Kindly select the month you are billing for.",
                type: "error", // Options: success, error, warning, info
                position: {vertical: "bottom", horizontal: "right"}, // Options for position
            });
            setBillLoading(false);
            return;
        }

        // Calculate estimated total for the confirmation dialog
        const estimatedTotal = finalBill.reduce((sum, bill) => sum + (bill.total_bill || 0), 0);

        // Prepare billing data for confirmation dialog
        const billingConfirmData = {
            month: getMonthName(parseInt(month.getMonth())).toUpperCase(),
            year: parseInt(month.getFullYear()),
            propertyName: tenant.property_name,
            tenantCount: finalBill.length,
            estimatedTotal: estimatedTotal
        };

        // Store the final bill data for later use
        setBillingDataForConfirm({
            finalBill,
            billingConfirmData
        });

        // Show the confirmation dialog instead of the basic confirm()
        setShowBillingConfirmDialog(true);
        setBillLoading(false); // Reset loading state while waiting for confirmation
    };

// New function to handle confirmation
    const handleBillingConfirm = async () => {
        setShowBillingConfirmDialog(false);
        setBillLoading(true);

        const {finalBill} = billingDataForConfirm;

        // Make Billing API Call
        try {
            const response = await fetch(ApiDetails + "pegasus/visionary/property/bill/tenants", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": getAuthToken() || ""
                },
                body: JSON.stringify([
                    ...finalBill,
                    {
                        month: parseInt(month.getMonth()),
                        year: parseInt(month.getFullYear()),
                        property_id: tenant.property_id,
                        property_name: tenant.property_name,
                    },
                ]),
            });

             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                const data = await response.json();
                console.log(data);
                setHtmlContent(data.htmlReport);

                showSnackbar({
                    title: "Success!",
                    message: "Tenants billed successfully.",
                    type: "success",
                    position: {vertical: "bottom", horizontal: "right"},
                });

                setBillLoading(false);
            } else {
                showSnackbar({
                    title: "Error!",
                    message: "Failed Billing tenants.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setBillLoading(false);
                handleClose();
            }
        } catch (err) {
            console.log(err);
            showSnackbar({
                title: "Error!",
                message: "Something Went Wrong. Call Customer Care For Assistance.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            setBillLoading(false);
            handleClose();
        }
    };

// New function to handle cancellation
    const handleBillingCancel = async () => {
        setShowBillingConfirmDialog(false);
        setBillLoading(false);
    };

    const downloadPDF = () => {
        //Make Billing API Call
        fetch(ApiDetails + "pegasus/visionary/property/bill/report", {
            method: "POST", body: JSON.stringify({
                pdf: htmlContent
            }),
        })
            .then(async (response) => {
                 // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {

                    let fileName;

                    for (let pair of response.headers.entries()) {
                        // accessing the entries
                        if (pair[0] === "content-disposition") {
                            // key I'm looking for in this instance
                            fileName = pair[1]; // saving that value where I can use it
                        }
                    }

                    showSnackbar({
                        title: "Success!",
                        message: "File download will start shortly",
                        type: "success", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });


                    let blob = await response.blob();

                    let href = window.URL.createObjectURL(blob);
                    // create "a" HTML element with href to file & click
                    const link = document.createElement("a");
                    link.href = href;
                    link.setAttribute("download", fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);

                    handleClose();


                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Failed downloading report",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                    setBillLoading(false);

                    handleClose();
                }
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong while downloading report",
                    type: "error", // Options: success, error, warning, info
                    position: {vertical: "bottom", horizontal: "right"}, // Options for position
                });
                setBillLoading(false);

                handleClose();
            });
    };

    const goBack = useGoBack();

    return (
        <>

            {/*Customer page dialog - Updated to match standard billing dialog*/}
            <Dialog
                fullWidth
                maxWidth="xl"
                fullScreen={isMobile}
                open={billTenantsModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    sx: {
                        borderRadius: isMobile ? 0 : 3,
                        overflow: 'visible',
                        margin: isMobile ? 0 : undefined,
                    }
                }}
            >
                <DialogTitle sx={{
                    pb: 1,
                    background: `linear-gradient(45deg, ${alpha(theme.palette.success.main, 0.1)}, ${alpha(theme.palette.success.light, 0.05)})`,
                    position: 'relative',
                    padding: isMobile ? '12px 16px' : '16px 24px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: isMobile ? 'wrap' : 'nowrap',
                        gap: isMobile ? 1 : 0,
                    }}>
                        <Box sx={{display: 'flex', alignItems: 'center', minWidth: 0}}>
                            <Box
                                sx={{
                                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                                    p: isMobile ? 0.75 : 1,
                                    borderRadius: 2,
                                    mr: isMobile ? 1.5 : 2,
                                    color: theme.palette.success.main
                                }}
                            >
                                <ReceiptLongIcon fontSize={isMobile ? "small" : "medium"}/>
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight="bold" noWrap>
                                    Bill Tenant
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                                    }}
                                >
                                    {tenant.first_name + " " + tenant.last_name} • {tenant.property_name}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={() => setBillTenantsModal(false)} size="small">
                            <CloseIcon/>
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent sx={{pt: isMobile ? 2 : 3, px: isMobile ? 2 : 3}}>
                    {htmlContent !== "" ? (
                        <Box sx={{
                            borderRadius: '12px',
                            border: '1px solid #e0e0e0',
                            padding: '24px',
                            backgroundColor: '#fff',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                            width: '100%'
                        }}>
                            <div dangerouslySetInnerHTML={{__html: htmlContent}}/>
                        </Box>
                    ) : (
                        <Box>
                            {/* Billing Month Selection */}
                            <Box sx={{
                                p: isMobile ? 2 : 3,
                                backgroundColor: "#f7f9fc",
                                borderRadius: 2,
                                mb: isMobile ? 2 : 3,
                                border: "1px solid #e0e7ff"
                            }}>
                                <Grid container spacing={isMobile ? 2 : 3}>
                                    <Grid item xs={12} md={6}>
                                        <Box sx={{display: "flex", alignItems: "center", gap: 1, mb: 2}}>
                                            <CalendarMonthIcon color="primary"/>
                                            <Typography variant="subtitle1" sx={{fontWeight: 600}}>
                                                Select Billing Month
                                            </Typography>
                                        </Box>

                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                views={["year", "month"]}
                                                value={month}
                                                onChange={(newValue) => {
                                                    console.log("Selected value :: ");
                                                    console.log(newValue);
                                                    setMonth(newValue);
                                                    setSelectedMonth(newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        variant="outlined"
                                                        label=""
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Box sx={{
                                            p: 2,
                                            backgroundColor: "#e3f2fd",
                                            borderRadius: 2,
                                            border: "1px solid #bbdefb"
                                        }}>
                                            <Box sx={{display: "flex", alignItems: "center", gap: 1, mb: 1}}>
                                                <InfoIcon color="info"/>
                                                <Typography variant="subtitle2" sx={{fontWeight: 600}}>
                                                    Billing Information
                                                </Typography>
                                            </Box>

                                            <Box sx={{display: "flex", alignItems: "center", gap: 1, mt: 1}}>
                                                <WaterDropIcon fontSize="small" color="info"/>
                                                <Typography variant="body2">
                                                    Water rate: <strong>{waterBill} KSH</strong> per
                                                    unit
                                                    (min: {minimumWaterBill} KSH)
                                                </Typography>
                                            </Box>

                                            <Box sx={{display: "flex", alignItems: "center", gap: 1, mt: 1}}>
                                                <ElectricBoltIcon fontSize="small" color="warning"/>
                                                <Typography variant="body2">
                                                    Electricity
                                                    rate: <strong>{electricityBill} KSH</strong> per
                                                    unit
                                                    (min: {minimumElecBill} KSH)
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Tenants DataGrid */}
                            <Box sx={{
                                height: isMobile ? 300 : 400,
                                width: '100%',
                                position: 'relative',
                                overflowX: 'auto',
                            }}>
                                {tenantList.length === 0 ? (
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%',
                                        backgroundColor: '#f9f9f9',
                                        borderRadius: 2,
                                        border: '1px solid #e0e0e0'
                                    }}>
                                        <PeopleAltIcon
                                            sx={{
                                                fontSize: 60,
                                                color: theme.palette.text.disabled,
                                                mb: 2
                                            }}
                                        />
                                        <Typography variant="h6" color="text.secondary" sx={{mb: 1}}>
                                            No Tenant Data
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Please check the tenant information.
                                        </Typography>
                                    </Box>
                                ) : (
                                    <StyledDataGrid
                                        getRowId={(row) => row.tenant_id}
                                        className={classes.root}
                                        initialState={{
                                            sorting: {
                                                sortModel: [{field: "house_number", sort: "asc"}],
                                            },
                                            pagination: {paginationModel: {pageSize: 10}}
                                        }}
                                        rows={tenantList}
                                        disableSelectionOnClick
                                        rowHeight={45}
                                        columns={billingColumns}
                                        rowsPerPageOptions={[5, 10]}
                                        sx={{
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                                        }}
                                    />
                                )}
                            </Box>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{
                    p: isMobile ? 2 : 3,
                    pt: 1,
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1 : 0,
                    '& .MuiButton-root': {
                        width: isMobile ? '100%' : 'auto',
                    }
                }}>
                    {htmlContent !== "" ? (
                        <>
                            <Button
                                variant="contained"
                                startIcon={<GetAppIcon/>}
                                onClick={downloadPDF}
                                fullWidth={isMobile}
                                sx={{
                                    background: `linear-gradient(45deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
                                    order: isMobile ? 1 : 0,
                                }}
                            >
                                Download PDF
                            </Button>
                            <Button
                                onClick={() => window.location.reload()}
                                color="inherit"
                                fullWidth={isMobile}
                                sx={{ order: isMobile ? 2 : 0 }}
                            >
                                Close
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                onClick={() => setBillTenantsModal(false)}
                                color="inherit"
                                fullWidth={isMobile}
                                sx={{ order: isMobile ? 2 : 0 }}
                            >
                                Cancel
                            </Button>
                            <LoadingButton
                                onClick={billTenant}
                                loading={billLoading}
                                variant="contained"
                                startIcon={<SendIcon/>}
                                fullWidth={isMobile}
                                sx={{
                                    borderRadius: 2,
                                    px: isMobile ? 2 : 3,
                                    background: `linear-gradient(45deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
                                    order: isMobile ? 1 : 0,
                                }}
                            >
                                Send Bills
                            </LoadingButton>
                        </>
                    )}
                </DialogActions>

                {/* Add the CardBillingConfirmationDialog */}
                <CardBillingConfirmationDialog
                    isOpen={showBillingConfirmDialog}
                    onConfirm={handleBillingConfirm}
                    onCancel={handleBillingCancel}
                    billingData={billingDataForConfirm?.billingConfirmData || {}}
                />
            </Dialog>

            <CardBillingConfirmationDialog
                isOpen={showBillingConfirmDialog}
                onConfirm={handleBillingConfirm}
                onCancel={handleBillingCancel}
                billingData={billingDataForConfirm?.billingConfirmData || {}}
            />


            {/*<Box bgcolor="#F7F9FA">*/}
            <Box>

                {/* Header Section */}
                <Box
                    sx={{
                        position: "sticky",
                        top: isMobile ? 56 : 65,
                        zIndex: 1000,
                        backgroundColor: "#F5F5F5",
                        borderBottom: "2px solid #2C5283",
                        padding: isMobile ? "8px 12px" : "10px 16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: isMobile ? "wrap" : "nowrap",
                        gap: isMobile ? 1 : 0,
                    }}
                >
                    {/* Left Section: Back button and Title */}
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        flex: isMobile ? "1 1 auto" : "0 0 auto",
                        minWidth: 0,
                    }}>
                        <IconButton
                            sx={{
                                color: "#2C5283",
                                marginRight: 1,
                                backgroundColor: "#F4F6F8",
                                padding: isMobile ? "6px" : "8px",
                            }}
                            onClick={goBack}
                            size={isMobile ? "small" : "medium"}
                        >
                            <ArrowBackIcon fontSize={isMobile ? "small" : "medium"}/>
                        </IconButton>
                        <Typography
                            variant={isMobile ? "subtitle1" : "h6"}
                            sx={{
                                fontWeight: "bold",
                                color: "#2C5283",
                                whiteSpace: isMobile ? "nowrap" : "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: isMobile ? "0.9rem" : "1.25rem",
                            }}
                        >
                            {isMobile
                                ? `${tenantData.first_name} ${tenantData.last_name}`.toUpperCase()
                                : `View Tenant - ${tenantData.first_name.toUpperCase()} ${tenantData.last_name.toUpperCase()}`
                            }
                        </Typography>
                    </Box>

                    {/* Right Section: Action Buttons - Desktop */}
                    {!isMobile && (
                        <Box sx={{display: "flex", gap: 1}}>
                            <MuiTooltip title="Coming soon" arrow>
                                <span>
                                    <Button
                                        variant="outlined"
                                        disabled={true}
                                        sx={{
                                            textTransform: "none",
                                            backgroundColor: "#FBF4F0",
                                            cursor: "not-allowed"
                                        }}
                                        onClick={() => {
                                            getTenantBills();
                                        }}
                                    >
                                        View Bill Details
                                    </Button>
                                </span>
                            </MuiTooltip>
                            <MuiTooltip title={props.isVacated ? "Cannot bill a vacated tenant" : ""} arrow>
                                <span>
                                    <Button
                                        variant="outlined"
                                        sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                        onClick={() => {
                                            setBillTenantsModal(true)
                                        }}
                                        disabled={props.isVacated}
                                    >
                                        Bill Tenant
                                    </Button>
                                </span>
                            </MuiTooltip>
                            <Button variant="outlined" sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                    onClick={() => {
                                        window.location.reload();
                                    }}>
                                Refresh Details
                            </Button>
                        </Box>
                    )}

                    {/* Mobile Menu Button */}
                    {isMobile && (
                        <>
                            <IconButton
                                onClick={handleMobileMenuOpen}
                                sx={{
                                    color: "#2C5283",
                                    backgroundColor: "#F4F6F8",
                                    padding: "6px",
                                }}
                                size="small"
                            >
                                <MenuIcon fontSize="small"/>
                            </IconButton>
                            <Menu
                                anchorEl={mobileMenuAnchor}
                                open={mobileMenuOpen}
                                onClose={handleMobileMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                PaperProps={{
                                    sx: {
                                        minWidth: 180,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                        borderRadius: '8px',
                                    }
                                }}
                            >
                                <MenuItem
                                    disabled={true}
                                    onClick={() => {
                                        getTenantBills();
                                        handleMobileMenuClose();
                                    }}
                                >
                                    View Bill Details
                                </MenuItem>
                                <MenuItem
                                    disabled={props.isVacated}
                                    onClick={() => {
                                        setBillTenantsModal(true);
                                        handleMobileMenuClose();
                                    }}
                                >
                                    Bill Tenant
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        window.location.reload();
                                    }}
                                >
                                    Refresh Details
                                </MenuItem>
                            </Menu>
                        </>
                    )}
                </Box>

                {/* Main Layout */}
                <Grid container spacing={isMobile ? 1 : 3} sx={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}>
                    {/* Left Section: Tenant Profile Card */}
                    <Grid item xs={12} md={4} lg={3}>
                        <LeftSide tenantID={props.tenant_id} propertyID={props.property_id} isVacated={props.isVacated}/>
                    </Grid>

                    {/* Right Section: Tabs and Content */}
                    <Grid item xs={12} md={8} lg={9}>
                        <RightSide tenantID={props.tenant_id} propertyID={props.property_id} tenantData={tenantData} isVacated={props.isVacated}/>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default CustomerPage;
